import { createAsyncThunk } from "@reduxjs/toolkit";

import { Role } from "src/models/Role";

import { axiosInstance as axios } from "../../../../api/axiosInstance";
import { format422 } from "../../../../utils/format422/format422";
import { showSnackbar } from "../../../reducers/snackbar/snackbarSlice";

export const deleteRole = createAsyncThunk(
  "deleteRole",
  async(role: Role | undefined, thunkAPI) => {
    const { dispatch, rejectWithValue } = thunkAPI;

    return axios.put(`/api/v1/roles/${role?.id}/delete`)
      .then((resp) => {
        dispatch(showSnackbar({
          message: "Role deleted successfully",
          variant: "success"
        }));

        return resp.data;
      })
      .catch((err) => {
        if (err.response.status === 422) {
          const errorMessage = format422(err.response.data.errors);

          dispatch(showSnackbar({
            message: errorMessage,
            variant: "error"
          }));

          return rejectWithValue(errorMessage);
        }

        const errorMessage = err.response.data.detail;

        dispatch(showSnackbar({
          message: errorMessage,
          variant: "error"
        }));

        return rejectWithValue(errorMessage);
      });
  }
);
